import axios from 'axios'
import Vue from 'vue';
import G from './../../global';
import router from './../router/index'
const vue = new Vue({
  router
});

// 域名地址
axios.defaults.baseURL = G.baseUrl;
let header = {'Content-Type': 'application/json', 'api-type':'admin', 'app-type': 'web','auth-token': localStorage.getItem('auth_token'),'current-user-id': localStorage.getItem('user_id'), };

//  REQUEST 请求异常拦截
axios.interceptors.request.use(config => {
  return config;

}, err => {
  // 错误处理
  // Message.error({ message: '请求超时!' });
  console.log(111,err)
  return Promise.reject(err);
});

//  RESPONSE 响应异常拦截
axios.interceptors.response.use(result => {
  return result;
}, err => {
  if (err && err.response) {

    switch (err.response.status) {
      case 401:
        err.message = '请求方式错误!';
        break;
      case 402:
        err.message = '请求参数错误!';
        break;
      default:
        err.message = `登录凭证过期,请重新登录!`;
    }
  } else {
    err.message = '连接服务器失败!00'
  }

  // Message.error({ message: err.message })
  return Promise.resolve(err);
});

// 接口域名
export const url = axios.defaults.baseURL;

// POST 方法封装 (处理参数与文件上传)
export const postRequest = (url, params) => {
  return axios({
    method: 'post',
    url: url,
    headers:header,
    data: params
  });
};


//  GET 方法封装
export const getRequest = (url, params) => {
  if (!localStorage.getItem('auth_token')) {
    // 非法进入时直接跳到登录页
    vue.$router.push('/login');
    return;
  };
  return axios({
    method: 'get',
    url: url,
    headers:header,
    data: params
  }).then(function(res){
    if(res.data.resid === 20004){
      vue.$router.push('/login');
    }else{
      return res;
    }
  });
};

//  PUT 方法封装
export const putRequest = (url, params) => {
  return axios({
    method: 'put',
    url: url,
    headers:header,
    data: params
  });
};

//  DELETE 方法封装
export const deleteRequest = (url, params) => {
  return axios({
    method: 'delete',
    url: url,
    headers:header,
    data: params
  });
};

//  GET 方法封装
export const getFileRequest = (url, params) => {
  if (!localStorage.getItem('auth_token')) {
    // 非法进入时直接跳到登录页
    vue.$router.push('/login');
    return;
  };
  return axios({
    method: 'get',
    url: url,
    headers:header,
    data: params,
    responseType: 'blob',
  }).then(function(res){
    if(res.data.resid === 20004){
      vue.$router.push('/login');
    }else{
      return res;
    }
  });
};



// WEBPACK FOOTER //
// ./src/utils/http.js